import * as React from 'react';
import {Segment, Form} from 'semantic-ui-react';
import {translate} from "react-i18next";
import PropTypes from 'prop-types';

class Login extends React.Component {
	state = {
		email: '',
		password: ''
	};
	
	handleChange = (e, {name, value}) => this.setState({[name]: value});
	handleSubmit = () => {
		this.props.onLogin(this.state);
	};
	
	render() {
		const {inline, grouped, t, processing} = this.props;
		const {email, password} = this.state;
		return (
			<div className="ah-login">
				<Segment>
					<Form onSubmit={this.handleSubmit} loading={processing}>
						<Form.Group inline={inline} grouped={grouped}>
							<Form.Input label={t('labels.email')} placeholder={t('labels.email')} name="email" value={email} onChange={this.handleChange}/>
							<Form.Input type="password" label={t('labels.password')} placeholder={t('labels.password')} name="password" value={password} onChange={this.handleChange}/>
							<Form.Field disabled={!email || !password} className="ah-button-holder">
								{!inline && !grouped && <label style={{visibility: 'hidden'}}>&nsbp;</label>}
								<Form.Button loading={processing}>{t('actions.login')}</Form.Button>
							</Form.Field>
						</Form.Group>
					</Form>
				</Segment>
			</div>
		);
	}
}

Login.propTypes = {
	onLogin: PropTypes.func.isRequired,
	isLoading: PropTypes.bool,
	inline: PropTypes.bool,
	grouped: PropTypes.bool,
	processing: PropTypes.bool
};
Login.defaultProps = {
	isLoading: false,
	inline: false,
	grouped: false,
	processing: false
};

export default translate()(Login);


// WEBPACK FOOTER //
// ./src/components/Login.js